import { Link } from 'react-router-dom';
import { useMyAgenda } from 'modules/jogador/agenda/useMyAgenda';
import { AgendaItemCard } from 'modules/jogador/agenda/components/AgendaItemCard';
import { Button } from 'shared/components/ui/Button';
import { ROUTES } from 'shared/constants/routes';
import { AsyncSection } from 'shared/components/ui/LoadingState';
import { AgendaItemSkeleton } from 'modules/jogador/agenda/components/AgendaItemSkeleton';

export function MyAgendaPage() {
  const { items, isLoading, error, confirmingId, requestCancel, dismissCancel, confirmCancel } = useMyAgenda();

  return (
    <section className="mx-auto max-w-2xl px-4 py-8">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-2xl font-bold text-ink">Minha Agenda</h1>
        <Link to={ROUTES.BOOKING}>
          <Button>+ Reservar</Button>
        </Link>
      </div>
      <p className="mt-1 text-sm text-ink-secondary">Seus próximos jogos, aulas e torneios.</p>

      <AsyncSection
        isLoading={isLoading}
        error={error}
        loadingLabel="Carregando sua agenda..."
        skeleton={
          <div className="mt-6 flex flex-col gap-3">
            <AgendaItemSkeleton />
            <AgendaItemSkeleton />
            <AgendaItemSkeleton />
            <AgendaItemSkeleton />
          </div>
        }
      >
        <div className="mt-6 flex flex-col gap-3">
          {items.map((item) => (
            <AgendaItemCard
              key={item.id}
              item={item}
              isConfirming={confirmingId === item.id}
              onRequestCancel={requestCancel}
              onDismissCancel={dismissCancel}
              onConfirmCancel={confirmCancel}
            />
          ))}
        </div>
      </AsyncSection>
    </section>
  );
}
